import TwoColumnModule from './TwoColumnModule';

export default TwoColumnModule;
